export default __webpack_public_path__ + "locales/ja-JP/Common.json?hash=48fc392a2a31364b54cd1d7b0bab5682";